/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyBankAccountStatus = {
  type: 'Enum',
} as const;
